import { useCallback, useEffect, useState } from 'react'
import { rpc, useRpcEvent } from '../api/rpc'
import type { ChatSummary } from '../api/types'
import { compareChatSummaries } from './chatListUtils'

export function useChatList(query?: string) {
  const [items, setItems] = useState<ChatSummary[]>([])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    try {
      const r = await rpc.call<{ items: ChatSummary[] }>('chats.list', { query: query ? query : undefined, limit: 100 })
      setItems(r.items)
    } finally {
      setLoading(false)
    }
  }, [query])

  useEffect(() => { void load() }, [load])
  useRpcEvent('rpc.reconnected', () => void load())
  useRpcEvent('chat.updated', (c: ChatSummary) => {
    if (query && !c.title.toLowerCase().includes(query.toLowerCase())) return
    setItems(prev => [c, ...prev.filter(x => x.id !== c.id)].sort(compareChatSummaries))
  })
  useRpcEvent('chat.deleted', (p: { id: string }) => setItems(prev => prev.filter(x => x.id !== p.id)))

  return { items, loading }
}
